import React from 'react';

const ComingSoon = () => {
  return (
    <div className="flex items-center justify-center h-screen bg-white-100">
      <h1 className="text-4xl font-bold text-black-800"> 🚀 Coming Soon</h1>
    </div>
  );
};

export default ComingSoon;
